import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { Portal } from '@chakra-ui/react';
import { Button, Flex, IconArrowRight, useToast } from '@cmpsr/components';
import { FC, useState } from 'react';
import { DECISION_TREE_CTA_TEST_ID } from '../../constants';
import { type CallToActionsProps } from './types';

export const mapCTA = {
  save: 'Save',
  next: 'Next',
  done: 'Done',
  close: 'Close',
  back: 'Back to Testing Plan',
};

export const CallToActions: FC<CallToActionsProps> = ({ isNextDisabled, goToNextSurveyItem, cta }) => {
  const [isLoading, setIsloading] = useState<boolean>(false);
  const toast = useToast();
  const handleNextClick = async () => {
    if (isNextDisabled) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error',
        description: 'Please answer the question before moving on.',
        status: 'error',
        position: 'top',
      });
      return;
    }
    setIsloading(true);
    try {
      await goToNextSurveyItem();
    } catch (error) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error',
        description: error,
        status: 'error',
        position: 'top',
      });
      setIsloading(false);
    }
    setIsloading(false);
  };

  return (
    <Portal>
      <Flex
        data-testid="call-to-action-container"
        justifyContent="center"
        position="fixed"
        bottom="0"
        w="100%"
        h={{ base: '50px', md: '80px' }}
        py={{ base: 0, md: 5 }}
        borderTopWidth={{ base: 0, md: '1px' }}
        borderTopStyle={{ base: 'none', md: 'solid' }}
        borderTopColor="ui-element-divider"
        bgColor="background-page"
        boxShadow="0px -5px 35px 0px #18334417"
        zIndex="1500"
      >
        <Button
          onClick={handleNextClick}
          variant="accent"
          size={{ base: 's', md: 'm' }}
          trailingIcon={cta === 'next' ? <IconArrowRight /> : undefined}
          isLoading={isLoading}
          width={{ base: '100%', md: '200px' }}
          borderRadius={{ base: 0, md: 'radii-button' }}
          data-testid={DECISION_TREE_CTA_TEST_ID}
        >
          {mapCTA[cta]}
        </Button>
      </Flex>
    </Portal>
  );
};
